<template>
  <Card v-bind="$attrs">
    <template #title>
      <div class="tw-flex tw-items-center tw-space-x-2">
        <Avatar
          :name="review.customer_name"
          shape="circle"
          size="large"
          :pt="{
            label: {
              class: 'tw-text-white tw-font-400 tw-text-lg',
            },
          }"
        />
        <div>
          <div class="tw-flex-inline tw-flex tw-space-x-1 tw-text-base tw-font-bold tw-text-gray-800">
            <span>{{ review.customer_name }}</span>
            <font-awesome-icon
              :icon="['fas', 'check-circle']"
              class="tw-mr-2 tw-h-4 tw-w-4 tw-pt-0.5"
              :style="{ color: $page.props.customisation.secondary_background }"
            />
          </div>
          <div class="tw-text-sm tw-font-normal tw-text-gray-400">
            <span>{{ review.submitted_on }}</span>
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <div class="tw-mb-3 tw-flex tw-items-center">
        <RatingStars :highlightedNumbers="review.rating" :starCount="totalStars" />
      </div>
      <div v-if="review.feedback" class="tw-whitespace-pre-line tw-text-sm tw-font-normal tw-text-gray-700">
        <p v-if="showEllipsis" v-snip="{ lines: lines, onSnipped: onSnipped, mode: 'js' }">
          {{ review.feedback }}
        </p>
        <p v-else>
          {{ review.feedback }}
        </p>
        <div class="tw-mt-2">
          <a
            href
            class="tw-w-fit tw-pt-2 tw-text-sm tw-font-normal tw-underline"
            :style="{ color: $page.props.customisation.secondary_background }"
            v-if="isReadMoreVisible"
            @click.prevent="$emit('showFeedbackModal', review)"
          >
            Read more
          </a>
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  review: Object,
  showEllipsis: {
    type: Boolean,
    default: true,
  },
});

defineEmits(['showFeedbackModal']);

let lines = props.review.response.message ? ref(2) : ref(3);
let hasEllipsis = ref(true);

const totalStars = 5;

const isReadMoreVisible = computed(() => props.showEllipsis && (hasEllipsis.value || props.review.response.message));

const onSnipped = newState => {
  hasEllipsis.value = newState.hasEllipsis;

  // So we can fit the 'read more' link drop back to 2 lines
  if (hasEllipsis.value) {
    lines.value = 2;
  }
};
</script>
